/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import { css, jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { PolarAreaChart } from './chart';
import { SubtitleCountRenderer } from 'components/virtualTooltip/renderers';
import { useChart } from 'hooks/useChart';

/**
 * PolarArea widget
 *
 * @param getColor
 * @param dimensions {{height: height, width: width}} to define value of chart
 * @param data Array of {key: key, value: value}
 */
export const PolarArea = ({ getColor, dimensions, data }) => {
	const svgRef = useRef();
	const containerRef = useRef();

	const options = useMemo(() => {
		return { colorScale: getColor };
	}, [getColor]);

	const { TooltipElement } = useChart({
		svgRef,
		containerRef,
		data,
		dimensions,
		options,
		Chart: PolarAreaChart,
		renderer: SubtitleCountRenderer,
	});

	return (
		<React.Fragment>
			{TooltipElement}
			<svg ref={svgRef} cy-test="polar-data" width={dimensions.width} height={dimensions.height} css={chartStyle}>
				<g ref={containerRef} transform={`translate(${dimensions.width / 2} ${dimensions.height / 2})`} />
			</svg>
		</React.Fragment>
	);
};

PolarArea.propTypes = {
	colorScale: PropTypes.any,
	data: PropTypes.any,
	dimensions: PropTypes.object,
};

const chartStyle = css`
	.gridGroup {
		line,
		path {
			stroke: lightgrey;
			stroke-dasharray: 2;
		}
	}
`;
